module.exports = __webpack_public_path__ + "static/img/101685.a96535e1.png";